module.exports = __webpack_public_path__ + "img/GALLERY-S-CROSS-4.86c0eb48.jpg";